import { createService } from '../../api';
import { TermsAndConditionsSchemas } from './TermsAndConditions.schemas';

export default createService(
  {
    getTermsAndConditions: {
      method: 'GET',
      url: '/termsandconditions/currentVersion',
      public: true,
      responseSchema: TermsAndConditionsSchemas,
    },
  },
  undefined,
);
